const FIELD_MAPPING = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
} as const

export const getField = (field: string): (typeof FIELD_MAPPING)[keyof typeof FIELD_MAPPING] =>
  FIELD_MAPPING[field as keyof typeof FIELD_MAPPING]
